import { render } from "./DashboardEventsListPage.vue?vue&type=template&id=5d9197d5&scoped=true"
import script from "./DashboardEventsListPage.vue?vue&type=script&lang=js"
export * from "./DashboardEventsListPage.vue?vue&type=script&lang=js"

import "./DashboardEventsListPage.vue?vue&type=style&index=0&id=5d9197d5&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9197d5"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QForm,QSpinner,QImg,QIcon,QCard,QFile,QTabs,QTab});
